import { AxiosError } from 'axios'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface GetTreatmentStatusProps {
  userName: string
  consultationType: string
  checkEligibility?: boolean
  planCode?: string
}

interface PatientTreatmentStatusData {
  cycleStatus: string
  cycleDate: string | null
}

interface Response {
  data: {
    status: string
    date: string | null
  }
}

// Centraliza plan_group, partner_plan_name e partner_plan_code que não devem passar pelo check de eligibilidade
const plansToDisableEligibilityCheck = [
  'CASSI',
  'CASSASSO',
  'CASSESSE',
  'CASSFAMI'
]

function handleEligibilityCheck(checkEligibility: boolean, planCode: string | undefined) {
  if (plansToDisableEligibilityCheck.includes(planCode)) {
    return false
  }

  return checkEligibility
}

const getTreatmentStatus = ({
  userName,
  consultationType = 'PSIQ',
  checkEligibility = false,
  planCode
}: GetTreatmentStatusProps): Promise<PatientTreatmentStatusData> => {
  const endpoint = apiEndpoints.PATIENT_TREATMENT_STATUS(userName)

  return new Promise<PatientTreatmentStatusData> ((resolve, reject) => {
    const params = {
      consultation_type: consultationType,
      check_eligibility: handleEligibilityCheck(checkEligibility, planCode),
      ...(planCode && { plan_code: planCode }),
    }
    axios.get(endpoint, { params })
      .then((response: Response) => {
        resolve({
          cycleStatus: response.data.status,
          cycleDate: response.data.date
        })
      })
      .catch(((err: AxiosError) => reject(err?.response?.status)))
  })
}

export {
  getTreatmentStatus
}